/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { Component, PropTypes } from 'react';
import { Modal, ModalFooter, ModalHeader, Button, Container } from 'src/components/Common/reactstrap/lib';

class GarageModalDelete extends React.Component {
  constructor(props) {
    super(props);

    this.deleteGarage = this.deleteGarage.bind(this);
  }

  deleteGarage() {
    this.props.deleteGarage(this.props.garageToDeleteId);
    this.props.close();
  }

  render() {
    return (
      <Modal isOpen={this.props.visible} toggle={this.props.close} className={this.props.className}>
        <ModalHeader toggle={this.props.close}>Удалить автомобиль?</ModalHeader>
        <Container>
        </Container>
        <ModalFooter>
          <Button onClick={this.props.close}>Нет</Button><Button color="primary" onClick={this.deleteGarage}>Да</Button>
        </ModalFooter>
      </Modal>
    );
  }
}


export default GarageModalDelete;



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/GarageModalDelete.jsx
 **/